import { Dialog, IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import React, { useState } from 'react';
import EditPaymentHistory from './EditPaymentHistory';


const options = ['Edit'];
const ITEM_HEIGHT = 48;

const PaymentHistoryOptions = ({ rowData, onEditSuccess }) => {
  const [openEdit, setOpenEdit] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseDialog = () => {
    setOpenEdit(false);
  };

  const handleEditClick = (option) => {
    handleClose();
    if (option === 'Edit') {
      setOpenEdit(true);
    }
  };


  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls={open ? 'payment-options-menu' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="payment-options-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: { maxHeight: ITEM_HEIGHT * 4.5, width: '20ch' }
        }}
      >
        {options.map((option) => (
          <MenuItem key={option} onClick={() => handleEditClick(option)}>
            {option}
          </MenuItem>
        ))}
      </Menu>

      <Dialog open={openEdit} onClose={handleCloseDialog}>
        {openEdit && (
          <EditPaymentHistory
            open={openEdit}
            handleClose={handleCloseDialog}
            selectedPayment={rowData}
            onEditSuccess={onEditSuccess}
          />
        )}
      </Dialog>
    </>
  );
};

export default PaymentHistoryOptions;